/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {createSignalr as ɵa} from './lib/modules/signalr-module';
export {SIGNALR_JCONNECTION_TOKEN as ɵb} from './lib/services/signalr.module';